import Dropdown from "react-bootstrap/esm/Dropdown";
import { FC } from "react";
import { IPageAction } from "../../../base/models";
import { MUIIcon } from "../../../widgets";
import { useGetTouUrl } from "../services/useTouUrl";

interface IActionDropdownTOULinkProps {
    action: IPageAction
}

export const ActionDropdownTOULink: FC<IActionDropdownTOULinkProps> = ({
    action
}) => {
    const { touUrl } = useGetTouUrl()
    
    if (!touUrl)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    return (
        <Dropdown.Item
            href={touUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Dropdown.Item>
    )
}